/* eslint-disable no-mixed-operators */
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Collapse } from 'reactstrap'
import { toast } from 'react-toastify'
import { I18n } from 'react-redux-i18n'
import { withRouter } from 'react-router-dom'

import { company as companyApi } from 'api'
import { poolsActions } from 'redux/actions'
import operatorActions from 'redux/actions/user'
import { fetchAssignedUsers } from 'redux/actions/assignedUsers'
import { addUserTab } from 'redux/actions/tabs'
import { addConversation } from 'redux/actions/conversations/conversations'
import { selectUser, updateUser } from 'redux/actions/conversations/user'
import UserCard from 'components/UserCard'
import ScrollableContent from '../../ScrollableContent'
import SideMenuFilters from '../SideMenuFilters'

class Index extends React.PureComponent {
  constructor(props) {
    super(props)

    this.selectUser = this.selectUser.bind(this)
    this.updateUser = this.updateUser.bind(this)
    this.unassignMe = this.unassignMe.bind(this)
    this.getFilterValue = this.getFilterValue.bind(this)
  }

  componentDidMount() {
    const {
      powerUser: { frontOptions = {} },
    } = this.props

    this.props.fetchAssignedUsers({
      order: frontOptions.orderAssigned,
      withPendingMsg: frontOptions.switchPendingAssigned,
      onlyAssignedToMe: frontOptions.checkedOnlyToMeAssigned,
      outbound: frontOptions.outboundAssigned,
      selectType: frontOptions.selectTypeAssigned,
      channels: frontOptions.channelsAssigned,
      brands: frontOptions.brandsAndDelegationsAssigned?.brands || [],
      delegations: frontOptions.brandsAndDelegationsAssigned?.delegations || [],
      categories: frontOptions.categoriesAssigned || [],
    })
  }

  componentDidUpdate(prevProps) {
    const { pools: { refreshCounter: prevRefreshCounter } } = prevProps
    const {
      pools: { refreshCounter },
      powerUser: { frontOptions = {} }
    } = this.props

    if (refreshCounter && prevRefreshCounter !== refreshCounter) {
      this.props.fetchAssignedUsers({
        order: frontOptions.orderAssigned,
        withPendingMsg: frontOptions.switchPendingAssigned,
        onlyAssignedToMe: frontOptions.checkedOnlyToMeAssigned,
        outbound: frontOptions.outboundAssigned,
        selectType: frontOptions.selectTypeAssigned,
        channels: frontOptions.channelsAssigned,
        brands: frontOptions.brandsAndDelegationsAssigned?.brands || [],
        delegations: frontOptions.brandsAndDelegationsAssigned?.delegations || [],
        categories: frontOptions.categoriesAssigned || [],
      })
    }
  }

  componentWillUnmount() {
    this.props.resetRefreshCounter()
  }

  selectUser(user) {
    const {
      tabs: { users },
    } = this.props

    const tabsContainSelectedUser = users.filter((u) => u === user.id).length > 0

    if (users.length < 15 || tabsContainSelectedUser) {
      this.props.history.push(`/dashboard/conversations/assignations?user_id=${user.id}`)
    }
  }

  updateUser(newData) {
    this.props
      .updateUser(newData)
      .then(() => toast(I18n.t('dashboard_unassigned-conversation'), { position: 'top-center' }))
      .catch(console.error)
  }

  unassignMe(user) {
    companyApi.assignationsUsers
      .remove({
        userId: user.id,
        operator: { id: this.props.powerUser._id, company: user.company },
        operatorIds: [this.props.powerUser._id],
      })
      .then(({ data }) => {
        if (data.statusOk) {
          // this.updateUser({ ...data.results })
        }
      })
      .catch(console.error)
  }

  getFilterValue(frontOptions) {
    const {
      switchPendingAssigned, orderAssigned, checkedOnlyToMeAssigned, outboundAssigned,
      selectTypeAssigned, channelsAssigned, categoriesAssigned, brandsAndDelegationsAssigned
    } = frontOptions || {}

    if (switchPendingAssigned) return true
    if (orderAssigned && orderAssigned !== 'desc') return true
    if (checkedOnlyToMeAssigned) return true
    if (outboundAssigned) return true
    if (selectTypeAssigned && selectTypeAssigned.value !== 'all') return true
    if (channelsAssigned && channelsAssigned.length) return true
    if (brandsAndDelegationsAssigned?.brands?.length || brandsAndDelegationsAssigned?.delegations?.length) return true
    if (categoriesAssigned?.length) return true

    return false
  }


  render() {
    const { selectTypeOptions, channelsOptions } = this.props
    const { activeUser } = this.props.tabs
    const { users: assignedUsers } = this.props.assignedUsers

    return (
      <div className='animated fadeIn'>
        <div className='sidemenu-container'>
          <div className='users-toggle'>
            <SideMenuFilters
              key='switchSideMenuAssignedUsers'
              options={{
                filter: {
                  value: this.getFilterValue(this.props.powerUser.frontOptions),
                  key: 'filter',
                  keys: ['orderAssigned', 'switchPendingAssigned', 'checkedOnlyToMeAssigned', 'outboundAssigned', 'selectTypeAssigned', 'channelsAssigned', 'brandsAndDelegationsAssigned', 'categoriesAssigned'],
                  pool: 'assignedUsers',
                  showTooltipOn: true,
                  tooltip: I18n.t('conversations_tooltip_filter')
                },
                order: {
                  key: 'orderAssigned',
                  value: this.props.powerUser.frontOptions?.orderAssigned,
                  tooltip: this.props.powerUser.frontOptions?.orderAssigned === 'asc'
                    ? I18n.t('dashboard_order_asc')
                    : I18n.t('dashboard_order_desc')
                },
                notRead: {
                  key: 'switchPendingAssigned',
                  value: this.props.powerUser.frontOptions?.switchPendingAssigned || false,
                  tooltip: I18n.t('conversations_tooltip_not_read'),
                  showTooltipOn: false
                },
                onlyToMe: {
                  key: 'checkedOnlyToMeAssigned',
                  value: this.props.powerUser.frontOptions?.checkedOnlyToMeAssigned || false,
                  tooltip: I18n.t('conversations_tooltip_multi'),
                  showTooltipOn: false
                },
                categories: {
                  key: 'categoriesAssigned',
                  value: this.props.powerUser.frontOptions?.categoriesAssigned,
                  tooltip: I18n.t('conversations_tooltip_categories'),
                  showTooltipOn: false
                },
                outbound: {
                  key: 'outboundAssigned',
                  value: this.props.powerUser.frontOptions?.outboundAssigned || false,
                  tooltip: I18n.t('conversations_tooltip_outbound'),
                  showTooltipOn: false
                },
                selectType: {
                  key: 'selectTypeAssigned',
                  value: this.props.powerUser.frontOptions?.selectTypeAssigned
                },
                selectTypeOptions,
                channels: {
                  key: 'channelsAssigned',
                  value: this.props.powerUser.frontOptions?.channelsAssigned
                },
                channelsOptions,
                brandsAndDelegations: {
                  key: 'brandsAndDelegationsAssigned',
                  value: this.props.powerUser.frontOptions?.brandsAndDelegationsAssigned
                }
              }}
            />
          </div>
          <div className='user-list-height'>
            <ScrollableContent
              goToTop
              className='user-list-height user-list-height--assigned-users'
            >
              <Collapse isOpen={true} className='m-0 users'>
                {assignedUsers.map((user, index) => (
                  <div key={user.id + index} className='wrapper-user-card'>
                    <UserCard
                      user={user}
                      isActive={activeUser === user.id}
                      unassignMe={this.unassignMe}
                      onClick={this.selectUser}
                      operatorCanAssignACardToItself={false}
                    />
                  </div>
                ))}
              </Collapse>
            </ScrollableContent>
          </div>
        </div>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchAssignedUsers,
      selectUser,
      addUserTab,
      addConversation,
      updateUser,
      updateOperator: operatorActions.updateOperator,
      resetRefreshCounter: poolsActions.resetRefreshCounter
    },
    dispatch
  )
}

export default connect(
  (state) => ({
    assignedUsers: state.assignedUsers,
    tabs: state.tabs,
    powerUser: state.user,
    company: state.companies,
    pools: state.pools
  }),
  mapDispatchToProps
)(withRouter(Index))
